import type {Base64Object, FlashcardCreateByCsvRequest} from '@cp/model';
import {createCallable} from './createCallable';

export const flashcardCreateByCsv = createCallable<FlashcardCreateByCsvRequest, Base64Object>('flashcardCreateByCsv');
